module.exports = __webpack_public_path__ + "img/efficiency-of-a-single-platform.d8a37cb7.jpg";